export const appconf_base = {
  url_ulog: null,
  send_debug_info: false,
  retry_interval: [500, 1250, 2500, 3000],
};
